
const isHtmlText = (htmlString: string): boolean => {
    const htmlTagPattern = /<([a-zA-Z]+)(\s[^>]*)?>.*?<\/\1>/s;
    const selfClosingTagPattern = /<([a-zA-Z]+)(\s[^>]*)?\/>/;

    return htmlTagPattern.test(htmlString) || selfClosingTagPattern.test(htmlString);
};

export const generatingHtmlString = (htmlString: string, isFromTextEditor: boolean) => {
    if (isFromTextEditor) {
        return htmlString;
    }

    return htmlString
        .replace(/^\n+|\n+$/g, '')
        .replace(/<</g, '&lt;&lt;')
        .replace(/>>/g, '&gt;&gt;')
        .split(/\r?\n/)
        .map(line => (isHtmlText(line) ? line : `<p>${line}</p>`))
        .join('');
};
